import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import axios from 'axios'
import ls from '@/ls'
import router from '@/router'
import { notification } from 'ant-design-vue'

Vue.use(Vuex)

const apiUrl = process.env.VUE_APP_API_URL
let token = ''
try {
  token = ls.get('token')
} catch (e) {
  ls.removeAll()
}

export const authStore: Module<any, any> = {
  namespaced: true,
  state: {
    status: '',
    token: token || '',
    authUser: ls.get('authUser') || {},
    permissions: ls.get('authUser') ? (ls.get('authUser').permissions || []) : [],
    roles: ls.get('authUser') ? (ls.get('authUser').roleNames || []) : []
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, { token, authUser }) {
      state.status = 'success'
      state.token = token
      state.authUser = authUser
      state.permissions = authUser.permissions || []
      state.roles = authUser.roleNames || []
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
      state.authUser = {}
    },
    setPermissions (state, permissions) {
      state.authUser.permissions = permissions
      state.permissions = permissions
      ls.set('authUser', state.authUser)
    },
    setRoles (state, roles) {
      state.roles = roles
    }
  },
  actions: {
    login ({ commit }, authUser) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({ url: apiUrl + '/login', data: authUser, method: 'POST' })
          .then(resp => {
            const token = 'Bearer ' + resp.data.access_token
            const authUser = resp.data.user
            ls.set('token', token)
            ls.set('authUser', authUser)
            axios.defaults.headers.common.Authorization = token
            commit('auth_success', { token, authUser })
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            ls.clear()
            reject(err)
          })
      })
    },
    getDetailsForO365User ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        const token = 'Bearer ' + data.token
        ls.set('token', token)
        axios.defaults.headers.common.Authorization = token
        axios({ url: apiUrl + '/users/o365', method: 'GET' })
          .then(resp => {
            const authUser = resp.data.user
            ls.set('authUser', authUser)
            commit('auth_success', { token, authUser })
            axios.defaults.headers.common.Authorization = token
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            ls.clear()
            reject(err)
          })
      })
    },
    logout ({ commit }, forcedLogout) {
      commit('logout')
      axios({ url: apiUrl + '/logout', method: 'POST' })
      ls.clear()
      delete axios.defaults.headers.common.Authorization
      router.push('/')

      if (forcedLogout) {
        notification.warning({ message: 'Sessie verlopen!', description: 'Uw sessie is verlopen. Log opnieuw in.', duration: 0 })
      }
    },
    setPermissions ({ commit }, permissions) {
      commit('setPermissions', permissions)
    },
    setRoles ({ commit }, roles) {
      commit('setRoles', roles)
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    authUser: state => state.authUser,
    authToken: state => state.token,
    permissions: state => state.permissions,
    canAny: state => (permissions: string[]) => {
      return permissions.some(p => state.permissions.includes(p))
    },
    hasRole: state => (role: string) => {
      return state.roles.includes(role)
    },
    hasAnyRole: state => (roles: string[]) => {
      return roles.some(r => state.roles.includes(r))
    }
  }
}
